import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none"><path fill="currentColor" d="M15.7 4.9v-.2l-.1-.2v.1h-.1l-.1.2h-3.8v-.2h.2l.1-.6h-.1c0-.2-.3-.8-1.2-1a1 1 0 0 0-1 .3 1 1 0 0 0 0 .2l-.1.2v.7l.2.1-.1.2h-.4C9 4.7 8.5 5 8 5.8l-.4 1h-.4l-.6 1.4v.1l.4.2-.2.6-.3.3-.3 1H6l-.2 1.4v.6l-.4.3a2.8 2.8 0 0 0-.5.5l-1 2.3a.4.4 0 0 0 0 .2v.5l-.4.6v.2h1.2l.1-.2V16L7 13.5l.2-.3 1-2.2h.1a.1.1 0 0 1 .1 0l.3.3.1.3.7.9a.8.8 0 0 0 .2.1l.1.1-.6 1-.3 1.3a.6.6 0 0 0 0 .1l-.2.9v.1a.4.4 0 0 0-.1.2l-.1.6h1.7a2.3 2.3 0 0 0 .5 0 .3.3 0 0 0 .1-.1l.1-.2a.1.1 0 0 0 0-.1l-.7-.3a.2.2 0 0 1-.1 0l-.2-.3.3-.4 1.2-2.7v-.5l-.4-.9h-.1L10 10a.3.3 0 0 1 0-.1l-.1-.7h.2l.7-1.3v-.1l-.1-.2.2-.2.5.3h.2l.5-.2.3-.7.1.4.9-.2-.2-.8V6a.2.2 0 0 0 .1 0v-.4H15.7V5h.9v-.2h-.8Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
